import { createSlice } from "@reduxjs/toolkit";

const initialApplicationState = {
  listLoading: false,
  actionsLoading: false,
  storeAppSubmissionList: [],
  countStoreAppSubmission: 0,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const slice = createSlice({
  name: "storeApp",
  initialState: initialApplicationState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.action) {
        state.actionsLoading = false;
      }
    },
    storeAppSubmissionsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;

      state.storeAppSubmissionList = entities;
      state.countStoreAppSubmission = totalCount;
    },
  },
});
